import { db } from '../firebase';
import firebase from 'firebase/app';

const PAGE_SIZE = 20;

export async function getQuotes({ page = 1, status = 'all', pageSize = 20 } = {}) {
  const snapshot = await db.collection('quotes').get();
  let items = snapshot.docs
    .map((doc) => ({ id: doc.id, ...doc.data() }))
    .filter(item => !item.isDeleted);

  if (status && status !== 'all') {
    items = items.filter(d => !!d.isPublished === (status === 'published'));
  }

  items.sort((a, b) => (a.orderIndex || 0) - (b.orderIndex || 0));

  const total = items.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const validPage = Math.max(1, Math.min(page, totalPages));
  const startIndex = (validPage - 1) * pageSize;
  const paginatedItems = items.slice(startIndex, startIndex + pageSize);

  return {
    items: paginatedItems,
    total,
    totalPages,
    page: validPage,
    pageSize,
    hasMore: startIndex + pageSize < total
  };
}

export async function getPrevQuotes() {
  return { items: [] };
}

export async function getQuoteById(id) {
  const doc = await db.collection('quotes').doc(id).get();
  if (!doc.exists) return null;
  return { id: doc.id, ...doc.data() };
}

export async function createQuote(data) {
  const maxOrder = await db.collection('quotes').orderBy('orderIndex', 'desc').limit(1).get();
  const orderIndex = maxOrder.empty ? 0 : (maxOrder.docs[0].data().orderIndex || 0) + 1;
  return db.collection('quotes').add({
    ...data,
    orderIndex,
    isPublished: data.isPublished || false,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    created_at: firebase.firestore.FieldValue.serverTimestamp(),
    updated_at: "",
    deleted_at: "",
  });
}

export async function updateQuote(id, data) {
  return db.collection('quotes').doc(id).update({
    ...data,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    updated_at: firebase.firestore.FieldValue.serverTimestamp(),
  });
}

export async function deleteQuote(id) {
  return db.collection('quotes').doc(id).update({
    isDeleted: true,
    deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    deleted_at: firebase.firestore.FieldValue.serverTimestamp()
  });
}

export async function reorderQuote(id, newOrderIndex) {
  return db.collection('quotes').doc(id).update({ orderIndex: newOrderIndex });
}

export async function getAllQuotes() {
  const snapshot = await db.collection('quotes').orderBy('orderIndex').get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function getTotalQuotes() {
  const snapshot = await db.collection('quotes').get();
  return snapshot.size;
}